import {
    CLEAR_FILTER,
    FLIGHT_DURATION_CHANGE,
    FLIGHT_DURATIONS_BATCH_RECEIVED,
    PARENT_FILTERS_CHANGED,
    RESET_ALL_FILTERS,
    SET_SELECTED_URL_FILTERS
} from "../../actions/FlightsActions";

export const initialState = {
    start: -1,
    end: -1,
    startSelected: -1,
    endSelected: -1,
    filterFromUrl: false
};

const FlightDurationFilterReducer = (state = initialState, action) => {
    switch (action.type) {
        case FLIGHT_DURATIONS_BATCH_RECEIVED:
            return {
                ...state,
                start: action.payload.min,
                end: action.payload.max,
                startSelected: !state.filterFromUrl
                    ? (
                        state.startSelected === state.start && state.startSelected !== initialState.startSelected
                        ? action.payload.min
                        : state.startSelected
                    )
                    : state.startSelected,
                endSelected: !state.filterFromUrl
                    ? (
                        state.endSelected === state.end && state.startSelected !== initialState.endSelected
                        ? action.payload.max
                        : state.endSelected
                    )
                    : state.endSelected
            };
        case FLIGHT_DURATION_CHANGE:
            return {
                ...state,
                startSelected: action.payload.start !== undefined ? action.payload.start : state.startSelected,
                endSelected: action.payload.end !== undefined ? action.payload.end : state.endSelected
            };
        case SET_SELECTED_URL_FILTERS:
            if (action.name === 'duration') {
                return {
                    ...state,
                    startSelected: parseInt(action.payload.start, 10),
                    endSelected: parseInt(action.payload.end, 10)
                };
            }

            return state;
        case PARENT_FILTERS_CHANGED:
            if (parseInt(action.filters.duration.start, 10) === initialState.start
                && parseInt(action.filters.duration.end, 10) === initialState.end
            ) {
                return state;
            }

            return {
                ...state,
                startSelected: action.filters.duration.start,
                endSelected: action.filters.duration.end,
                filterFromUrl: true
            };
        case CLEAR_FILTER:
            if (action.filter === 'duration') {
                return {...state, startSelected: initialState.startSelected, endSelected: initialState.endSelected};
            }

            return state;
        case RESET_ALL_FILTERS:
            return {...state, startSelected: initialState.startSelected, endSelected: initialState.endSelected};
        default:
            return state
    }
};

export default FlightDurationFilterReducer;



// WEBPACK FOOTER //
// ./src/reducers/filters/FlightDurationFilterReducer.js